import { Logo as LogoUI } from "@repo/ui-parkmobile/Logo";
import type { CardLogo } from "@/generated/sb";
import { imageStoryblokResolver } from "@/lib/storyblok/adaptors";

export default function Logo({ blok }: { blok: CardLogo }) {
  const { image, backgroundColor } = blok;

  const imageBlok = image?.[0];
  const imageAsset = imageStoryblokResolver(imageBlok);

  return (
    <LogoUI image={imageAsset} backgroundColor={backgroundColor || "default"} />
  );
}